export enum BankingPaths {
    ROOT = "banks",
    IMPORT = "parse-transaction",
    TRANSACTIONS = "bank-transactions",
}
